import moment from 'moment';
import { useContext, useMemo } from 'react';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import { Line } from 'react-chartjs-2';
import {
  CategoryScale,
  Chart,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Tooltip,
  Title,
} from 'chart.js';
import { Box, ColorContext } from 'dash-ui';

Chart.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Filler,
  Tooltip,
  Title
);

const ViewedByAgentsChart = ({ data }: { data: any[] }) => {
  const { getRandomColor } = useContext(ColorContext);
  const { suggestedMax, ...chartData } = useMemo(() => {
    const labelMoments = uniqBy(
      data.map(({ createdAt }) => moment(createdAt)),
      (v) => v.format('MMM/DD')
    );
    let suggestedMax = 0;

    const dataSetsGroup = groupBy(data, 'propertyId');
    const datasets = Object.keys(dataSetsGroup).map((key) => {
      const property = dataSetsGroup[key][0].property;
      const views = dataSetsGroup[key];
      const data = labelMoments.map(
        (a) =>
          views.filter((item) => {
            const b = moment(item.createdAt);
            return (
              a.get('year') === b.get('year') &&
              a.get('month') === b.get('month') &&
              a.get('day') === b.get('day')
            );
          }).length
      );

      suggestedMax = Math.max(...data, suggestedMax);

      const color = getRandomColor();

      return {
        label: property.name,
        data: data,
        borderColor: color,
        backgroundColor: color,
        fill: true,
      };
    });

    return {
      labels: labelMoments.map((value) => value.format('MM/DD')),
      datasets,
      suggestedMax,
    };
  }, [data, getRandomColor]);

  return (
    <Box w="100%" h={321}>
      <Line
        data={chartData}
        options={{
          responsive: true,
          aspectRatio: 2,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: true,
            },
            tooltip: {
              mode: 'index',
            },
          },
          interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
          },
          scales: {
            y: {
              suggestedMin: 0,
              suggestedMax: Math.max(
                suggestedMax + Math.round(suggestedMax * 0.3),
                2
              ),
            },
          },
        }}
      />
    </Box>
  );
};

export default ViewedByAgentsChart;
